import axios from 'axios'
import { Indicator, MessageBox } from 'mint-ui'

const instance = axios.create({
  baseURL: '/arcfoxDigital/api'
})

let loading
let loadingNum = 0
instance.interceptors.request.use(config => {
  if (!config.ignoreLoading) {
    loadingNum++
    loading = true
    Indicator.open({
      text: '加载中...',
      spinnerType: 'fading-circle'
    })
  }
  return config
}, error => {
  return error
})

instance.interceptors.response.use(response => {
  if (!response.config.ignoreLoading) {
    loadingNum--
    if (loading && loadingNum <= 0) {
      loading = false
      loadingNum = 0
      Indicator.close()
    }
  }
  return response.data
}, error => {
  if (loading) {
    loadingNum = 0
    Indicator.close()
  }
  MessageBox('提示', '服务器内部错误,请稍候重试！')
  return error
})

export default {
  ...instance
}
